import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'artists_landing_page';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { artistsLandingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
